module.exports = __webpack_public_path__ + "static/media/lesson_chapter_2.09c7ad7c.png";